import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetPostComments, EResetPostCommentsActionType } from './types';

export const resetPostComments: () => TResetPostComments = actionGenerator<EResetPostCommentsActionType.Reset>(
  EResetPostCommentsActionType.Reset,
);
